function trimTrailingSlash(url: string) {
  return url.replace(/\/+$/, '');
}

function normalizeEnvUrl(rawUrl: string | undefined) {
  const trimmedUrl = rawUrl?.trim();
  if (!trimmedUrl) {
    return '';
  }

  return trimTrailingSlash(trimmedUrl);
}

export function getBrowserOriginUrl() {
  if (typeof window === 'undefined') {
    return '';
  }

  return trimTrailingSlash(window.location.origin);
}

export function getApiBaseUrl() {
  const configuredUrl = normalizeEnvUrl(import.meta.env.VITE_API_URL);
  if (configuredUrl) {
    return configuredUrl;
  }

  if (typeof window === 'undefined') {
    return '';
  }

  const { protocol, hostname } = window.location;
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';

  if (isLocalHost) {
    return `${protocol}//${hostname}:3001`;
  }

  return getBrowserOriginUrl();
}

export function getAppSelectorUrl() {
  return normalizeEnvUrl(import.meta.env.VITE_APP_SELECTOR_URL) || getBrowserOriginUrl();
}

export function getLoansAppUrl() {
  return normalizeEnvUrl(import.meta.env.VITE_LOANS_URL) || getBrowserOriginUrl();
}

export function getExternalAppUrl(rawUrl: string | undefined) {
  return normalizeEnvUrl(rawUrl) || getAppSelectorUrl() || getBrowserOriginUrl();
}
